import { render, staticRenderFns } from "./UserRoleInfo.vue?vue&type=template&id=7824648b&scoped=true&"
import script from "./UserRoleInfo.vue?vue&type=script&lang=js&"
export * from "./UserRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824648b",
  null
  
)

export default component.exports